/* @flow */

import WebshopAnnouncementBar from './WebshopAnnouncementBar'
import WebshopBanner from './WebshopBanner'
import WebshopLinkButtonWidget from './WebshopLinkButtonWidget'
import WebshopCenteredContent from './WebshopCenteredContent'
import WebshopGrid from './WebshopGrid'
import WebshopHeaderV2 from '../WebshopHeaderV2'
import WebshopHeaderBackdrop from './WebshopHeaderBackdrop'
import WebshopProductCarousel from './WebshopProductCarousel'
import WebshopTextWidget from './WebshopTextWidget'

const webshopWidgets = {
  announcement_bar: WebshopAnnouncementBar,
  banner: WebshopBanner,
  centered_content: WebshopCenteredContent,
  grid: WebshopGrid,
  header: WebshopHeaderV2,
  header_backdrop: WebshopHeaderBackdrop,
  link_button: WebshopLinkButtonWidget,
  product_carousel: WebshopProductCarousel,
  text: WebshopTextWidget,
}

export default webshopWidgets
